import React from 'react';
import { IconMailOpened, IconMail } from '@tabler/icons-react';

const NotificationsDropdownListing = (props) => {
  const { dropdown_notifications, handleNotificationStatus } = props;

  return dropdown_notifications.slice(0, 5).map((notification, index) => {
    return (
      <span
        key={index}
        className={notification.is_read === true ? 'read notification-item' : 'unread notification-item'}
        title={notification.is_read === true ? 'Read' : 'Mark as read'}
        onClick={() => handleNotificationStatus(notification.id, notification.is_read)}
      >
        <span className="notification-item-text">{notification.message}</span>
        <IconMail stroke={1.5} className="icon-mail" />
        <IconMailOpened className="icon-mail-opened" stroke={1.5} />
      </span>
    );
  });
};

export default NotificationsDropdownListing;
